import {
  actions as parentActions,
  state as parentState,
  mutations as parentMutations,
} from '~/sites/shop/store/category'
import gql from 'graphql-tag'

const state = () => ({
  ...parentState(),
  categoriesStock: {},
  categoriesCustom: {},
})

const actions = {
  ...parentActions,
  async FETCH_HOMEPAGE_CATEGORIES({ commit, dispatch }) {
    try {
      const cmsResponse = await this.app.apolloProvider.defaultClient.query({
        query: gql`
          query {
            configuration_categories_custom {
              title
              configurable_categories {
                ... on configurable_category {
                  title
                  category_item_type
                  action_title
                  type
                  configurable_categories {
                    entityType
                    entity {
                      ... on StoreCategory {
                        data
                      }
                    }
                  }
                }
              }
            }
            configuration_categories_stock {
              title
              configurable_categories {
                ... on configurable_category {
                  title
                  category_item_type
                  action_title
                  type
                  configurable_categories {
                    entityType
                    entity {
                      ... on StoreCategory {
                        data
                      }
                    }
                  }
                }
              }
            }
          }
        `,
      })
      commit('SET_HOMEPAGE_CATEGORY', {
        name: 'categoriesCustom',
        config: cmsResponse.data.configuration_categories_custom,
      })
      commit('SET_HOMEPAGE_CATEGORY', {
        name: 'categoriesStock',
        config: cmsResponse.data.configuration_categories_stock,
      })
    } catch (e) {
      console.error(e)
    }
  },
}

const mutations = {
  ...parentMutations,
  SET_HOMEPAGE_CATEGORY: (state, { name, config }) => {
    state[name] = config
  },
}

export { actions, mutations, state }
